import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import colors from '../../config/colors';

const MultiSelectQuestion = ({ question, value, onChange }) => {
  const toggleOption = (optionValue) => {
    if (value.includes(optionValue)) {
      onChange(value.filter(v => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  };

  return (
    <div style={{ padding: '12px 0' }}>
      <h2 style={{
        fontSize: 'clamp(1.5rem, 3vw, 2rem)',
        fontWeight: '700',
        color: colors.textPrimary,
        marginBottom: '8px',
        lineHeight: '1.2'
      }}>
        {question.question}
      </h2>

      {question.subtitle && (
        <p style={{
          fontSize: '1rem',
          color: colors.textSecondary,
          marginBottom: '20px'
        }}>
          {question.subtitle}
        </p>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px' }}>
        {question.options.map((option) => {
          const isSelected = value.includes(option.value);
          
          return (
            <motion.button
              key={option.value}
              onClick={() => toggleOption(option.value)}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              style={{
                background: isSelected ? colors.brandPrimary : colors.bgCard,
                border: `2px solid ${isSelected ? colors.brandPrimary : colors.borderMedium}`,
                borderRadius: '12px',
                padding: '16px 18px',
                textAlign: 'left',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}
            >
              {/* Checkbox */}
              <div style={{
                width: '24px',
                height: '24px',
                borderRadius: '6px',
                border: `2px solid ${isSelected ? colors.textInverse : colors.borderStrong}`,
                background: isSelected ? colors.textInverse : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                {isSelected && <Check size={16} color={colors.brandPrimary} strokeWidth={3} />}
              </div>

              {/* Label */}
              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: '1.05rem',
                  fontWeight: '600',
                  color: isSelected ? colors.textInverse : colors.textPrimary
                }}>
                  {option.label}
                </div>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default MultiSelectQuestion;
